import { render, staticRenderFns } from "./yxyw.vue?vue&type=template&id=0534108e&scoped=true&"
import script from "./yxyw.vue?vue&type=script&lang=js&"
export * from "./yxyw.vue?vue&type=script&lang=js&"
import style0 from "./yxyw.vue?vue&type=style&index=0&id=0534108e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0534108e",
  null
  
)

export default component.exports